module.exports = __webpack_public_path__ + "img/background047.52fdab3f.jpg";